import { IProjectDeprecated, IPsetAndProperty } from "@mctypes/global.types";
import { IMCBIMAPI } from "@mctypes/mcbim.types";
import Axios from "axios";

export const doGetActiveMcBimProjects = async (): Promise<IProjectDeprecated[]> => {
  try {
    const resp = await Axios.get("/api/systemadmin/activemcprojects");
    return resp.data;
  } catch (error) {
    return Promise.reject({ type: "backend", message: error.response?.data });
  }
};

export const doEnableMcBim = async (
  maconomyProjectNo: string,
  adminEmail: string,
  fileAttributeExtractSettings: IMCBIMAPI.AllFourFileAttributeExtracSettings,
  psetsFilter: string[],
  pns: IPsetAndProperty,
  defaultProp: IPsetAndProperty,
): Promise<IProjectDeprecated[]> => {
  try {
    const fetchData = await Axios.post("/api/systemadmin/createmcbimproject", {
      maconomyProjectNo,
      adminEmail,
      fileAttributeExtractSettings,
      psetsFilter,
      pns,
      defaultProp,
    });
    return fetchData.data?.data;
  } catch (error) {
    return Promise.reject({ type: "backend", message: error.response?.data });
  }
};
